import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { UserDAO } from '../../../../../../core/services/dao/userDAO';
import { VesselDAO } from '../../../../../../core/services/dao/vesselDAO';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConstantMan } from '../../../../../../core/services/constantMan';
import { take } from 'rxjs/operators';
import { VesselAvailabilityDAO } from '../../../../../../core/services/dao/VesselAvailabilityDAO';
import { NumberFormatterService } from '../../../../../../core/services/number.formatter.service';
import { MooringLocationDAO } from '../../../../../../core/services/dao/mooringLocationDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Component({
  selector: 'app-vessel-save-button',
  templateUrl: './vessel-save-button.component.html',
  styleUrls: ['./vessel-save-button.component.scss'],
})
export class VesselSaveButtonComponent implements OnInit {
  @Input()
  model: Partial<Vessel>;

  @Input()
  selectedWaterBodies: any[];

  @Input()
  vesselStatus: string;

  @Input()
  currentTab: string;

  subs: Subscription[] = [];
  modelSaving = false;
  isAdmin = false;
  tabDefs = ConstantMan.VESSEL_FORM_TABS;
  canSave: boolean;

  constructor(
    private userDAO: UserDAO,
    private vesselDAO: VesselDAO,
    private snackBar: MatSnackBar,
    private vesselAvailabilityDAO: VesselAvailabilityDAO,
    private formatter: NumberFormatterService,
    private mooringLocationDAO: MooringLocationDAO,
  ) {}

  ngOnInit(): void {
    this.userDAO.getCurrentUser().roles.map((role) => {
      if (role.adminAccess) {
        this.isAdmin = true;
      }
    });
    this.setCanSave();
  }

  saveModel() {
    if (this.model) {
      this.modelSaving = true;
      this.formatPrices();
      const saveSub = this.vesselDAO
        .updateFromPartial(this.model.id, this.model)
        .subscribe((res) => {
          if (this.currentTab === this.tabDefs.BOAT_LOCATION) {
            const mooringSub = this.mooringLocationDAO
              .updateMooringLocation(this.model.mooringLocation, this.model.id)
              .subscribe((updatedMooringLocation) => {});
            this.subs.push(mooringSub);

            if (this.selectedWaterBodies) {
              const ids = [];
              this.selectedWaterBodies.forEach((wb) => {
                ids.push(wb.id);
              });
              const waterBodySub = this.vesselDAO
                .updateVesselWaterBodies(this.model.id, ids)
                .subscribe((data) => {});
              this.subs.push(waterBodySub);
            }
          }

          const availSub = this.vesselAvailabilityDAO
            .updateFullAvailabilitiesForVessel(this.model.id)
            .pipe(take(1))
            .subscribe();
          this.subs.push(availSub);

          this.openSnackbar(`Vessel ${this.currentTab} Saved`);
          this.modelSaving = false;
        });
      this.subs.push(saveSub);
    }
  }

  formatPrices() {
    if (this.model.cashValue) {
      this.model.cashValue = `${this.formatter.unMaskPrice(
        this.model?.cashValue,
      )}`;
    }

    if (this.model.fuelBillingRate) {
      this.model.fuelBillingRate = this.formatter.unMaskPrice(
        this.model?.fuelBillingRate,
      );
    }

    if (this.model.fuelReimbursementRate) {
      this.model.fuelReimbursementRate = this.formatter.unMaskPrice(
        this.model?.fuelReimbursementRate,
      );
    }

    if (this.model.depositAmount) {
      this.model.depositAmount = this.formatter.unMaskPrice(
        this.model?.depositAmount,
      );
    }
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  showSaveButtonForAdmin(): boolean {
    // show only on Select tabs for admin view
    if (
      this.currentTab === this.tabDefs.AVAILABILITY ||
      this.currentTab === this.tabDefs.CHARTER_SCHEDULE ||
      this.currentTab === this.tabDefs.HISTORY
    ) {
      return false;
    }
    return true;
  }

  showSaveButtonForBoatOwner() {
    // show save button only on Select tabs for Boat Owner - New Boat
    if (this.canSave) {
      return this.showSaveButtonForAdmin();
    } else if (
      // show save button only on Select tabs for Boat Owner - Active
      this.currentTab === this.tabDefs.AVAILABILITY ||
      this.currentTab === this.tabDefs.CAPTAIN_INFO ||
      this.currentTab === this.tabDefs.CHARTER_SCHEDULE ||
      this.currentTab === this.tabDefs.HISTORY ||
      this.currentTab === this.tabDefs.PRICING_EDITOR ||
      this.currentTab === this.tabDefs.CAPTAIN_INFO ||
      this.currentTab === this.tabDefs.REQUEST_EDIT
    ) {
      return false;
    }
    return true;
  }

  setCanSave() {
    this.canSave =
      this.vesselStatus === ConstantMan.VESSEL_STATUSES.DRAFT ||
      this.vesselStatus === ConstantMan.VESSEL_STATUSES.PENDING ||
      this.isAdmin;
  }
}
